module.exports = __webpack_public_path__ + "img/paper.5ed27b8d.svg";